import { render, staticRenderFns } from "./BusinessPartner.vue?vue&type=template&id=0b0e6012&"
import script from "./BusinessPartner.vue?vue&type=script&lang=js&"
export * from "./BusinessPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports